<intrasense-error-all [title]="title"  [description]="description" (navigateEvent)="navigateTo($event)"></intrasense-error-all>